module.exports = __webpack_public_path__ + "img/cart_btn.ae6832d0.svg";